import { render, staticRenderFns } from "./AlbumItems.vue?vue&type=template&id=38abc892&scoped=true"
import script from "./AlbumItems.vue?vue&type=script&lang=js"
export * from "./AlbumItems.vue?vue&type=script&lang=js"
import style0 from "./AlbumItems.vue?vue&type=style&index=0&id=38abc892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abc892",
  null
  
)

export default component.exports